import { FC, ReactNode } from 'react';

import { ThemeSwitcher } from '@thirdspacelearning/library';
import { useKeycloakAuth } from '@tsl-frontend/tsl-keycloak-auth';

import { isPrimaryStudent } from '@utils';

const ThemeSwitch: FC<Record<string, unknown>> = ({ children }) => {
    const { user } = useKeycloakAuth();

    const paramString = window.location.search;

    const defaultTheme = isPrimaryStudent(user) ? 'primary' : 'secondary';

    return (
        <ThemeSwitcher
            parameterString={paramString}
            defaultTheme={defaultTheme}
            children={children as ReactNode}
        />
    );
};

export default ThemeSwitch;
